/**
 * Xizmat yo'nalishlari va tayyor savollar.
 *
 * === Nega faqat ikkita yo'nalish ===
 *
 * Dizaynda beshta yo'nalish bor edi: ST-1, Mahalliy, Import, TIF TN,
 * Maslahat. Lekin backend faqat IKKITASINI haqiqatan bajara oladi:
 *
 *   tiftn    -> kaskad kodni topadi (`src/core/`)
 *   consult  -> bilim bazasi javob beradi (`src/kb/`)
 *
 * Qolgan uchtasi uchun serverda maxsus mantiq YO'Q. Ularni ko'rsatish
 * foydalanuvchiga mavjud bo'lmagan xizmatni va'da qilardi.
 *
 * Kod o'chirilmadi — pastda izohda turibdi. Backend tayyor bo'lganda
 * izohdan chiqariladi.
 */

export const SERVICES = [
  {
    id: "tiftn",
    title: "TIF TN kodini aniqlash",
    icon: "layers",
  },
  {
    id: "consult",
    title: "Nomenklatura bo'yicha savol-javob",
    icon: "messages",
  },

  // === KELAJAKDA: backend mantiqi yozilgach ochiladi ===
  //
  // Bularning har biri alohida ish oqimi talab qiladi (kelib chiqish
  // mezonlari, lokalizatsiya hisobi, imtiyoz tekshiruvi) — bu faqat
  // interfeys masalasi emas.
  //
  // {
  //   id: "origin",
  //   title: "Tovarlarni kelib chiqishini sertifikatlashtirish",
  //   short: "ST-1, REX va Form A — MDH va YeI uchun 0% boj",
  //   icon: "shield",
  // },
  // {
  //   id: "local",
  //   title: "Mahalliy ishlab chiqarilgan tovarni sertifikatlashtirish",
  //   short: "Mahalliylashtirish darajasi va texnologik xarita",
  //   icon: "chart",
  // },
  // {
  //   id: "import",
  //   title: "Import tovarlarni imtiyozli ekspertiza qilish",
  //   short: "Yangi uskunalar va xomashyo uchun 0% boj imtiyozi",
  //   icon: "percent",
  // },
];

export const serviceById = (id) =>
  SERVICES.find((s) => s.id === id) || SERVICES[0];
